const VERSION = '2.0.11a'
export default VERSION
